// frontend/src/pages/LoginPage.js

import React, { useState } from "react";
import axios from "axios";
import '../styles/LoginPage.css'; // <<< IMPORTANT: Import the new CSS file >>>

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("BASE_URL:", BASE_URL);


export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");

  function handleLogin(e) {
    e.preventDefault();

    // --- CRITICAL DEBUGGING LOGS (ensure these are present and visible) ---
    console.log("--- Login Attempt Initiated ---");
    console.log("Username state (before Axios):", username);
    console.log("Password state (before Axios):", password);
    console.log("BASE_URL:", BASE_URL); 
    // --- NEW LOGS ---
    console.log("Is username falsy?", !username);
    console.log("Is password falsy?", !password);
    // --- END NEW LOGS ---
    console.log("--- End Login Attempt Log ---");
    // --- END DEBUGGING LOGS ---
    
    // Basic guard: If states are empty, don't even make the API call.
    if (!username || !password) {
      setMsg("Please enter both username and password.");
      console.warn("Login attempt aborted: Username or password state is empty.");
      return;
  }

    axios.post(`${BASE_URL}/api/login`, { username, password })
    .then(res => {
      localStorage.setItem('currentUser', JSON.stringify(res.data)); 
      onLogin(res.data);
    })
    .catch((error) => { 
        console.error("Login API call failed:", error); 
        if (error.response && error.response.status === 401) {
            setMsg("Invalid username or password!");
        } else {
            setMsg(`Login failed: ${error.message || "Network error"}`);
        }
    });
  }

  return (
  <div className="login-page-wrapper"> {/* NEW WRAPPER DIV */}
   <div className="login-container"> {/* Main container for the login page */}
      <h2 className="login-title">Queue Management System</h2> {/* Styled title */}
      <h2 className="login-title">Login</h2> {/* Styled title */}

      <form onSubmit={handleLogin} className="login-form"> {/* Styled form */}
        <input
          type="text" // Explicitly set type for username
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          className="login-input" // Styled input
          required
          autoComplete="off"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="login-input" // Styled input
          required
          autoComplete="new-password"
        />
        <button type="submit" className="login-button">Login</button> {/* Styled button */}
      </form>
      <div className="login-message">{msg}</div> {/* Styled message area */}
    </div>
  </div>
  );
}